<footer class="flex flex-row justify-center h-20">
  <small class="flex flex-row justify-center items-center text-gray-500" [ngClass]="{'flex-row-reverse': dir == 'rtl'}">
      <span  class="px-1">
          <i class="fal fa-copyright"></i>
          <span>&nbsp;{{displayYear()}}</span>
      </span>
      <img src="/assets/img/footer-logo.svg" class="h-4 px-1" />
  </small>
</footer>